import React from 'react';
import { Navigate } from 'react-router-dom';
import { useModules } from '../../context/ModuleContext';

const ModuleProtectedRoute = ({ children, moduleCode }) => {
  const { isModuleEnabled, loading } = useModules();
  
  // Wait for modules to load before checking
  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <p>Loading...</p>
      </div>
    );
  }
  
  // If module is not enabled, show a message instead of redirecting (to prevent loops)
  if (!isModuleEnabled(moduleCode)) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <h2>Module Not Enabled</h2>
        <p>The {moduleCode} module is not enabled for your tenant.</p>
        <p>Please contact your administrator to enable this module.</p>
      </div>
    );
  }
  
  return children;
};

export default ModuleProtectedRoute;

